module.exports = __webpack_public_path__ + "static/media-flake-4bae4ebfe3bc3756538120471ce4dc6f.png";